/** @jsx jsx */
import React from 'react';
import { jsx, Box, Grid } from 'theme-ui';
import theme from '../../gatsby-plugin-theme-ui';
import SectionContainer from './sectionContainer';
import SectionMedia from './sectionMedia';

const Section = ({
  aspectHeight,
  aspectWidth,
  backgroundColor,
  backgroundColorOverride,
  backgroundMedia,
  backgroundImage,
  backgroundVideo,
  children,
  fullWidthContainer,
  gridGap,
  gridColumnOverride,
  mediaObjectFit,
  mediaObjectPosition,
  sectionSize,
}) => {
  return (
    <SectionContainer
      aspectHeight={aspectHeight}
      aspectWidth={aspectWidth}
      backgroundColor={backgroundColor}
      backgroundColorOverride={backgroundColorOverride}
      sectionSize={sectionSize}
    >
      <SectionMedia
        backgroundMedia={backgroundMedia}
        backgroundImage={backgroundImage}
        backgroundVideo={backgroundVideo}
        mediaObjectFit={mediaObjectFit}
        mediaObjectPosition={mediaObjectPosition}
      />
      <Box
        sx={{
          maxWidth: fullWidthContainer ? '100%' : theme.sizes.container,
          minWidth: fullWidthContainer ? '100%' : theme.sizes.container,
          mx: 'auto',
          position: 'relative',
          px: ['0', '0'],
          zIndex: 10,
        }}
      >
        <Grid
          columns={[
            'auto',
            gridColumnOverride || React.Children.count(children) || 1,
          ]}
          gap={gridGap}
          sx={{ gridAutoRows: ['auto', 'auto', 'auto', '1fr'] }}
        >
          {children}
        </Grid>
      </Box>
    </SectionContainer>
  );
};

export default Section;
